export class MembreComite {
    id: number|undefined;
    nom:string;
    prenom:string;
    civilite:string;
    entreprise:string;
    poste:string;
    businessEmail:string;
}